//selectors for the editor data...
export const getEditorSettings = state => state.editor.settings;

export default {getEditorSettings};